import { m } from '../../mithril';
import { SCALE } from '../animation/scale';
import { SPIN } from '../animation/spin';
import { addStyles, DefaultTheme, rgba } from '../theme';
import { GOOGLE_BLUE } from '../theme.palette';

export const CSS = {
	container: 'c-Spinner',
	isExiting: 'c-Spinner--is-exiting',
	circle: 'c-Spinner__circle',
	buttonSize: 'c-Spinner--big',
};

const FADE_TIME = 150;
const SPIN_TIME = 1100;
const CONTAINER_SIZE = DefaultTheme.space(6);
const CIRCLE_SIZE = DefaultTheme.space(4);

addStyles({
	[CSS.container]: {
		width: CONTAINER_SIZE,
		height: CONTAINER_SIZE,
		'align-self': 'center',
		animation: `${SCALE.IN} ${FADE_TIME}ms`,
	},
	[CSS.circle]: {
		height: CIRCLE_SIZE,
		width: CIRCLE_SIZE,
		margin: '2px',
		border: `2px solid ${rgba(GOOGLE_BLUE)}`,
		borderTopColor: 'transparent',
		borderRadius: '50%',
		animation: `${SPIN} ${SPIN_TIME}ms infinite linear`,
	},
	[CSS.buttonSize]: {
		width: DefaultTheme.space(8),
	},
	['mdl-button .' + CSS.container]: {
		margin: 'auto',
	},
});

function view(className: string = '') {
	return m('div', { className: `${CSS.container} ${className}` }, [m('div', { className: CSS.circle })]);
}

export const Spinner = { view, CSS };
